import { T } from '../../styles/theme'

export default function MacroChart({ data, goals, theme = T, width = 320, height = 130 }) {
  const W = width, H = height, PL = 44, PB = 24, PT = 10, PR = 12
  const cW = W - PL - PR, cH = H - PB - PT

  if (!data || data.length < 2) return (
    <div style={{ textAlign: 'center', color: theme.muted, padding: 20, fontSize: 13 }}>
      Necesitas al menos 2 días de registro
    </div>
  )

  const n = data.length
  const maxV = Math.max(
    ...data.flatMap(d => [d.prot, d.gras, d.carb]),
    goals?.proteina_objetivo ?? 0,
    goals?.grasa_objetivo ?? 0,
    goals?.carbohidratos_objetivo ?? 0
  ) + 20
  const xScale = i => PL + (i / (n - 1)) * cW
  const yScale = v => PT + (1 - v / maxV) * cH

  const configs = [
    { key: 'prot', color: theme.blue, obj: goals?.proteina_objetivo },
    { key: 'gras', color: theme.warn, obj: goals?.grasa_objetivo },
    { key: 'carb', color: theme.purple, obj: goals?.carbohidratos_objetivo },
  ]

  const yTicks = [0, Math.round(maxV / 2), Math.round(maxV)]

  return (
    <svg width="100%" viewBox={`0 0 ${W} ${H}`}>
      {yTicks.map(v => (
        <line key={'tick' + v} x1={PL} x2={W - PR} y1={yScale(v)} y2={yScale(v)} stroke={theme.cardB} strokeWidth="1" strokeDasharray="3,3" />
      ))}
      {configs.map(({ key, color, obj }) => {
        if (!obj) return null
        const margin = 10
        const y1 = yScale(obj + margin)
        const y2 = yScale(obj - margin)
        return <rect key={key + 'band'} x={PL} y={y1} width={cW} height={y2 - y1} fill={color} opacity="0.08" />
      })}
      {configs.map(({ key, color, obj }) => {
        if (!obj) return null
        const y = yScale(obj)
        return (
          <g key={key + 'obj'}>
            <line x1={PL} x2={W - PR} y1={y} y2={y} stroke={color} strokeWidth="1" strokeDasharray="4,3" opacity="0.6" />
            <text x={PL - 4} y={y - 3} textAnchor="end" fill={color} opacity="0.7" fontSize="7" fontFamily="DM Mono, monospace">Obj.{obj}g</text>
          </g>
        )
      })}
      {configs.map(({ key, color }) => {
        const pts = data.map((d, i) => `${xScale(i)},${yScale(d[key])}`).join(' ')
        return <polyline key={key} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" points={pts} />
      })}
      {data.filter((_, i) => i === 0 || i === Math.floor(n / 2) || i === n - 1).map((d) => {
        const i = data.indexOf(d)
        return <text key={i} x={xScale(i)} y={H - 4} textAnchor="middle" fill={theme.muted} fontSize="9" fontFamily="DM Sans, sans-serif">{d.label}</text>
      })}
      <line x1={PL} x2={PL} y1={PT} y2={H - PB} stroke={theme.cardB} strokeWidth="1" />
      <line x1={PL} x2={W - PR} y1={H - PB} y2={H - PB} stroke={theme.cardB} strokeWidth="1" />
    </svg>
  )
}
